export const FINANCE_ROUTE_PREFIX = '/finance';

export const COMPANIES_EE_LABEL = 'Companies';
export const COMPANIES_VALUE_BASED_EE_LABEL = 'Companies (value-based)';
export const BUILDINGS_EE_LABEL = 'Real estate';
export const PERSONAL_MOTOR_VEHICLES_EE_LABEL = 'Vehicles';
